<template>
    <div class="wrap btn-position-wrap">
        <div class="client-box">
            <section class="add-user global-section">
                <div class="row">
                    <div class="col-12 form-error" v-if="formError">{{ formError }}</div>
                </div>
                <div class="row">
                    <md-button class="md-icon-button cancel-add-user" @click="cancelAddUser()">
                        <md-icon>clear</md-icon>
                    </md-button>
                    <div class="col-3">
                        <h2 class="section-title">Add New Users</h2>
                    </div>
                    <div class="col-9">
                        <div class="dynamic-contacts">
                            <div class="row" v-for="(user, index) in newUsers">
                                <div class="col-12">
                                    <div class="avatar-block">
                                        <div class="row">
                                            <div class="col-5">
                                                <div class="avatar upload s-48 gray">
                                                    <md-icon class="icon icon-person"></md-icon>
                                                </div>
                                                <div class="client-name-box">
                                                    <div class="line-item">
                                                        <md-field class="md-block">
                                                            <md-input v-model="user.firstName" placeholder="First Name*" @blur="userTouchHanlder(index, 'firstName')"></md-input>
                                                        </md-field>
                                                        <div class="new-user-error" v-if="validationErrors['newUsers.' + index + '.firstName']">{{ validationErrors['newUsers.' + index + '.firstName'][0] }}</div>
                                                    </div>
                                                    <div class="line-item">
                                                        <md-field class="md-block client-name without-line" md-no-float>
                                                            <md-input v-model="user.email" placeholder="Email*" @blur="userTouchHanlder(index, 'email')"></md-input>
                                                        </md-field>
                                                        <div class="new-user-error" v-if="validationErrors['newUsers.' + index + '.email']">{{ validationErrors['newUsers.' + index + '.email'][0] }}</div>
                                                    </div>
                                                    <div class="line-item">
                                                        <md-field class="md-block without-line" md-no-float>
                                                            <md-input v-model="user.title" placeholder="Position*" @blur="userTouchHanlder(index, 'title')"></md-input>
                                                        </md-field>
                                                        <div class="new-user-error" v-if="validationErrors['newUsers.' + index + '.title']">{{ validationErrors['newUsers.' + index + '.title'][0] }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-5">
                                                <div class="line-item">
                                                    <md-field class="md-block">
                                                        <md-input v-model="user.lastName" placeholder="Last Name*" @blur="userTouchHanlder(index, 'lastName')"></md-input>
                                                    </md-field>
                                                    <div class="new-user-error" v-if="validationErrors['newUsers.' + index + '.lastName']">{{ validationErrors['newUsers.' + index + '.lastName'][0] }}</div>
                                                </div>
                                                <div class="line-item">
                                                    <md-field class="md-block">
                                                        <md-input v-model="user.directPhone" placeholder="Direct #*" @blur="userTouchHanlder(index, 'directPhone')"></md-input>
                                                    </md-field>
                                                    <div class="new-user-error" v-if="validationErrors['newUsers.' + index + '.directPhone']">{{ validationErrors['newUsers.' + index + '.directPhone'][0] }}</div>
                                                </div>
                                                <div class="line-item">
                                                    <md-field class="md-block">
                                                        <md-input v-model="user.officePhone" placeholder="Office #" @blur="userTouchHanlder(index, 'officePhone')"></md-input>
                                                    </md-field>
                                                    <div class="new-user-error" v-if="validationErrors['newUsers.' + index + '.officePhone']">{{ validationErrors['newUsers.' + index + '.officePhone'][0] }}</div>
                                                </div>
                                            </div>
                                            <md-button v-if="hasMultipleUsers" aria-label="Delete User" class="md-icon-button delete-btn" @click="deleteUser(index)">
                                                <md-icon>delete</md-icon>
                                            </md-button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 showClientList">
                                    <div v-if="!clientActive" class="primary-contact">
                                        <div v-if="isSuperAdmin">
                                            <md-checkbox v-model="user.isSuperAdmin" aria-label="Primary Contact" @change="setUserAsAdmin(index)">
                                                Cortex Super Admin
                                            </md-checkbox>
                                        </div>
                                        <div>
                                            <md-checkbox v-model="user.isAdmin" aria-label="Primary Contact" v-if="!user.isSuperAdmin">
                                                Cortex Admin
                                            </md-checkbox>
                                        </div>
                                        <div id="demo" v-if="clientList.length > 0 && !user.isAdmin">
                                            <div v-for="(client, index) in clientList">
                                                <input type="checkbox" v-model="user.clientId" name="test" class="multiple_select" :key="index" :value="client.id"/>
                                                <label>{{ client.companyName }}</label>
                                            </div>
                                        </div>
                                        <div v-else><h3>No clients available.</h3></div>
                                    </div>
                                </div>
                            </div>
                            <div class="add-button">
                                <md-button class="md-icon-button md-primary" aria-label="Add User" @click="addUser()">
                                    <md-icon>add</md-icon>
                                </md-button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div class="bottom-btn-position">
                <div class="wrap">
                    <md-button class="save-user-button md-primary" aria-label="Add New Client" @click="clickSaveNewUser()">Save</md-button>
                </div>
            </div>
        </div>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDialog">
            <div class="user-saving-message">
                <span>
                    <md-progress-spinner class="md-accent user-saving-spinner" :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>
                    Saving User(s)...
                </span>
            </div>
        </md-dialog>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDialogForUserLimit">
            <md-dialog-content>
                Your user limit is full please contact to admin.
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtncancel" @click="closeDialogForUserLimit">OK</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
import {required, email} from 'vuelidate/lib/validators';
import {saveNewUsers} from '../../services/UserService.js';
import {notWhitespace, validPhoneNumber} from '../../includes/validations.js';

function uniqueEmail (value) {
  let contacts = this.newUsers;
  let matches = 0;
  for (let contact of contacts) {
    if (contact.email) {
      if (contact.email.toLowerCase() === value.toLowerCase()) {
        matches = matches + 1;
      }
    }
  }
  return matches <= 1;
}

export default {
  data: () => ({
    newUsers: [
      {
        firstName: null,
        lastName: null,
        title: null,
        email: null,
        officePhone: null,
        directPhone: null,
        clientId: [],
        isAdmin: false,
        isSuperAdmin: false,
        isPrimaryContact: false
      }
    ],
    formError: null,
    showDialog: false,
    showDialogForUserLimit: false,
    validationErrors: []
  }),
  computed: {
    ...mapGetters('client', ['clientActive', 'clientList', 'currentClient']),
    ...mapGetters('user', ['isSuperAdmin']),
    hasMultipleUsers () {
      return this.newUsers.length > 1;
    }
  },
  methods: {
    setUserAsAdmin: function (index) {
      let newUsers = this.newUsers;
      if (newUsers[index].isSuperAdmin) {
        newUsers[index].isAdmin = true;
      }
      this.newUsers = newUsers;
    },
    userTouchHanlder (index, key) {
      if (!this.$v.newUsers.$each[index][key].$dirty) {
        this.$v.newUsers.$each[index][key].$touch();
      }
    },
    cancelAddUser () {
      this.$router.push('/settings/users');
    },
    addUser () {
      let newUser = {
        firstName: null,
        lastName: null,
        title: null,
        email: null,
        officePhone: null,
        directPhone: null,
        isAdmin: false,
        isSuperAdmin: false,
        isPrimaryContact: false
      };
      if (this.clientActive) {
        newUser.clientId = this.currentClient.id;
      } else {
        newUser.clientId = null;
      }
      this.validationErrors = [];
      this.newUsers.push(newUser);
    },
    deleteUser (index) {
      // remove the validations from the deleted user
      let validationErrors = this.validationErrors;

      if (validationErrors['newUsers.' + (index) + '.firstName']) {
        delete validationErrors['newUsers.' + (index) + '.firstName'];
        delete validationErrors['newUsers.' + (index) + '.lastName'];
        delete validationErrors['newUsers.' + (index) + '.email'];
        delete validationErrors['newUsers.' + (index) + '.directPhone'];
        delete validationErrors['newUsers.' + (index) + '.title'];
      }

      this.validationErrors = validationErrors;

      if (this.newUsers[index].isPrimaryContact) {
        if (index === 0) {
          this.newUsers[1].isPrimaryContact = true;
        } else {
          this.newUsers[0].isPrimaryContact = true;
        }
      }

      this.newUsers.splice(index, 1);
    },
    async closeDialogForUserLimit () {
      this.showDialogForUserLimit = false;
    },
    async clickSaveNewUser () {
      this.showDialog = true;
      this.validationErrors = [];
      await saveNewUsers(this.newUsers)
        .then(response => {
          if (response.data === 0) {
            this.showDialog = false;
            this.showDialogForUserLimit = true;
          } else {
            this.$router.push('/settings/users');
            this.showDialog = false;
          }
        })
        .catch(error => {
          this.formError = '';
          if (error.response.data.type === 'DUPLICATE_EMAIL') {
            this.formError = error.response.data.message;
          }

          if (error.response.data.errors) {
            this.validationErrors = error.response.data.errors;
          }

          this.showDialog = false;
        });
    }
  },
  validations: {
    newUsers: {
      $each: {
        firstName: {
          required,
          notWhitespace
        },
        lastName: {
          required,
          notWhitespace
        },
        title: {
          required,
          notWhitespace
        },
        email: {
          required,
          email,
          uniqueEmail
        },
        directPhone: {
          required,
          notWhitespace,
          validPhoneNumber
        },
        officePhone: {
          required,
          notWhitespace,
          validPhoneNumber
        },
        clientId: {
          required
        }
      }
    }
  },
  mounted () {
    if (this.clientActive) {
      this.newUsers[0].clientId = this.currentClient.id;
    }
  }
};
</script>
<style lang="scss" scoped>
.save-user-button {
    background-color: #00A8CA;
    font-size: 14px !important;
    font-weight: 500;
}

.new-user-error {
    margin-top: -20px;
    font-size: 11px;
    color: red;
}

.form-error {
    font-size: 15px;
    color: red;
}

.add-button button {
    background-color: #00A8CA !important;
    font-size: 14px !important;
    font-weight: 500 !important;
}

.add-button button:hover {
    background-color: #00788A !important;
}

.client-name-box {
    margin-top: 0 !important;
    padding-top: 0 !important;
}

.add-user.global-section {
    margin-top: 30px;
}

.cancel-add-user {
    float: right;
}

.user-saving-message {
    padding: 10px;
    height: 70px;
    margin: auto;

    .user-saving-spinner {
        margin-right: 20px;
    }
}

.showClientList {
    width: 80%;
    float: left;
    margin-left: 8%;
}

#demo {

    height: 150px;
    overflow: auto;
}

.multiple_select {
    width: 20px;
    min-width: 22px;
    height: 20px;
    position: relative;
    border-radius: 2px;
    border: 2px solid transparent;
    cursor: pointer;
}

.ManualBtn {
    display: inline-block !important;
    margin-bottom: 0 !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    -ms-touch-action: manipulation !important;
    touch-action: manipulation !important;
    cursor: pointer !important;
    background-image: none !important;
    border: 1px solid transparent !important;
    padding: 6px 12px !important;
    font-size: 14px !important;
    line-height: 1.42857143 !important;
    border-radius: 4px !important;
    color: #fff !important;
}

.ManualBtncancel {
    margin: 10px !important;
    color: white !important;
    background-color: #00a8ca !important;
    border-color: #ccc !important;
}

</style>



// WEBPACK FOOTER //
// src/components/settings/AddUser.vue